module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/Qacuta/Tokyo_Qacuta_MIROC5_RCP45_Now.png";